import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { FileUploadInput as DocUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { changeDateFormat } from '@ifca-root/react-component/src/helpers/Functions/dateFunction'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import { MenuItem, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { DropdownTextfield } from 'containers/ARAPModule/Components/DropdownTextField'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  DocumentListingDocument,
  GetApAdvanceDocument,
  RecordStatus,
  useCreateApAdvanceMutation,
  useDocumentListingLazyQuery,
  useGetBankAccountQuery,
  useGetCompanySummaryQuery,
  useGetCreatedAccPeriodDateRangeQuery,
  useGetCreditCardTypeQuery,
  useGetCreditorAccountCompanyAssignmentNameQuery,
  useGetDocNumTitleQuery,
  useGetPaymentMethodNameQuery,
  useLatestOpenPeriodCheckingDateQuery,
  useUpdateApAdvanceMutation,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  formatDashDate,
  getDatePlusDay,
} from 'helpers/StringNumberFunction/FormatDate'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import * as yup from 'yup'
import '../APAdvance.scss'

interface APAdvanceProps {
  CompanyID: string
  CreditorAccountID: string
  AdvanceID: string
  DocDate: string
  TrxDate: string
  DocAmt: number
  RefNo: string
  Description: string
  Remark: string
  Attachment: null
  debitAmt: number
  approval: string
  user: string
  BankAccountID: string
  BankName: string
  PaymentMethodID: string
  CreditCardID: string
  ChequeNo: string
  ChequeDate: string
  Amount: number
  uploadAttach: string
  DocNo: string
  CompanyName: string
}
interface FavAPAdvanceProps {
  Name: string
}

export const APAdvanceForm = (props: any) => {
  const { formMode, type } = props

  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }

  let history = useHistory()
  let location = useLocation()
  const editData = location?.state as any
  const { CompanyID, AdvanceID }: any = useParams()
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [openExitDialog, setopenExitDialog] = useState(false)
  const [PaymentValidation, setPaymentValidation] = useState(false)
  const [valuepicked, setValuePicked] = useState<String>(null)
  const [initDocs, setInitDocs] = useState([])
  const [isSubmit, setIsSubmit] = useState(false)
  const [voiceRemark, setVoiceRemark] = useState('')
  const [record, setRecord] = useState(false)

  useEffect(() => {
    if (editData?.Attachment) {
      setInitDocs(editData?.Attachment)
    }
  }, [editData])

  //Creditor Account Company Assignment//
  const {
    loading: CreditorAccountCompanyAssignmentLoading,
    error: CreditorAccountCompanyAssignmentError,
    data: { getCreditorAccountCompanyAssignment } = {
      getCreditorAccountCompanyAssignment: [],
    },
  } = useGetCreditorAccountCompanyAssignmentNameQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
    },
  })

  let creditorAcc = getCreditorAccountCompanyAssignment?.map(x => {
    return x?.CreditorAccount
  })

  //PaymentMethod
  const {
    loading: PaymentMethodLoading,
    error: PaymentMethodError,
    data: { getPaymentMethod } = { getPaymentMethod: [] },
  } = useGetPaymentMethodNameQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
  })

  const {
    called: bankAccountCalled,
    loading: bankAccountLoading,
    data: { getBankAccount } = { getBankAccount: [] },
  } = useGetBankAccountQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RecordStatus: RecordStatus?.Active,
    },
  })

  const {
    loading: docNumHeaderLoading,
    error: docNumHeaderError,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID, RefTable: 'AP_Advance' },
  })

  const {
    loading: openPeriodCheckDateLoading,
    data: { latestOpenPeriodCheckingDate } = {
      latestOpenPeriodCheckingDate: {} as any,
    },
  } = useLatestOpenPeriodCheckingDateQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  const {
    loading: createdAccPeriodRangeLoading,
    data: { getCreatedAccPeriodDateRange } = {
      getCreatedAccPeriodDateRange: {} as any,
    },
  } = useGetCreatedAccPeriodDateRangeQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
    },
  })

  const {
    loading: CompanyLoading,
    data: { getCompany: curCompany } = { getCompany: [] },
  } = useGetCompanySummaryQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },
    onCompleted: ({ getCompany }) => {},
  })

  //CreditCardType
  const {
    loading: CreditCardTypeLoading,
    error: CreditCardTypeError,
    data: { getCreditCardType } = { getCreditCardType: [] },
  } = useGetCreditCardTypeQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: {},
  })

  const APAdvanceFormSchema = yup.object().shape({
    DocDate: yup.string().required('Doc Date is Required'),
    TrxDate: yup.string().required('Transaction Date is Required'),
    RefNo: CommonYupValidation.requireField(SystemMsgs.referenceNo()),
    CreditorAccountID: yup.string().required('Creditor Name is Required'),
    Description: CommonYupValidation.requireField(SystemMsgs.description()),
    PaymentMethodID: CommonYupValidation.requireField(
      'Payment Method is required'
    ),
    CreditCardID:
      PaymentValidation && valuepicked?.includes('Card')
        ? CommonYupValidation.requireField('Credit Card Type is required')
        : null,
    ChequeNo: yup.string().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.string().required('Cheque no. is required'),
      otherwise: null,
    }),
    ChequeDate: yup.date().when('PaymentMethodID', {
      is: getPaymentMethod?.find(method => method?.Name === 'Cheque')
        ?.PaymentMethodID,
      then: yup.date().required('Cheque date is required'),
      otherwise: null,
    }),
    BankAccountID: CommonYupValidation.requireField('Bank Account is required'),
    DocAmt: yup
      .number()
      .required('Amount is required')
      .moreThan(0)
      .typeError('Amount is required'),
  })

  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    watch,
    getValues,
    clearErrors,
    formState,
  } = useForm<APAdvanceProps>({
    defaultValues: {
      CompanyID: editData ? editData?.CompanyID : '',
      DocDate: editData ? editData?.DocDate : new Date(),
      TrxDate: editData ? editData?.TransactionDate : new Date(),
      RefNo: editData ? editData?.RefNo : '',
      CreditorAccountID: editData ? editData?.CreditorAccountID : '',
      BankAccountID: editData ? editData?.BankAccountID : '',
      PaymentMethodID: editData ? editData?.PaymentMethodID : '',
      CreditCardID: editData ? editData?.CreditCardID : '',
      ChequeNo: editData ? editData?.ChequeNo : '',
      ChequeDate: editData ? editData?.ChequeDate : new Date(),
      DocAmt: editData ? editData?.DocAmt : 0,
      Amount: editData ? editData?.Amount : 0,
      Description: editData ? editData?.Description : '',
      Remark: editData ? editData?.Remark : '',
      Attachment: editData ? editData?.Attachment : '',
      DocNo: editData
        ? editData?.DocNo !== null
          ? editData?.DocNo
          : undefined
        : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(APAdvanceFormSchema),
  })

  const [selectedBank, setSelectedBank] = useState(null)
  // select bank
  const handleBankChange = event => {
    setSelectedBank(
      getBankAccount.find(x => x?.BankAccountID === event?.target?.value)
    )
  }

  //Changing PaymentMethodID
  const [selectedPM, setSelectedPM] = useState(null)
  const paymentmethod: any = getPaymentMethod

  const handlePMChange = event => {
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque' ||
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setPaymentValidation(true)
    } else setPaymentValidation(false)
    if (
      getPaymentMethod?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name === 'Cheque'
    ) {
      setValuePicked('Cheque')
    } else if (
      getPaymentMethod
        ?.find(el => el?.PaymentMethodID === event?.target?.value)
        ?.Name?.includes('Card')
    ) {
      setValuePicked('Card')
    } else setValuePicked('')
  }

  //Changing If PM chosed CreditCard
  const [selectedCC, setSelectedCC] = useState(null)
  const creditcard: any = getCreditCardType

  const handleCCChange = event => {
    setSelectedCC(
      creditcard.find(x => x?.CreditCardID === event?.target?.value)
    )
  }

  useEffect(() => {
    if (editData?.Remark) {
      setValue('Remark', editData?.Remark)
    }
  }, [editData])

  // Edit Bank Account
  useEffect(() => {
    if (!!editData && !!getBankAccount) {
      setSelectedBank(
        getBankAccount?.find(e => e?.BankAccountID === editData?.BankAccountID)
      )
    }
  }, [editData, getBankAccount])

  //////////////////////////////////////
  //...........ATTACHMENTS.............//
  ///////////////////////////////////////
  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  const [
    loadDoc,
    { loading: DocLoad, error: DocError, data: DocData },
  ] = useDocumentListingLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ DocumentListing }) => {
      if (!editData?.files) {
        handleEditUpload(
          DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
        )
        previewFiles?.push(
          ...DocumentListing?.filter(
            doc => doc?.description !== 'document_pdf'
          )?.map(x => x?.fileURL)
        )
      }
    },
  })

  useEffect(() => {
    if (!DocLoad && formMode !== 'add') {
      loadDoc({ variables: { refID: AdvanceID } })
    }
    if (editData?.files) {
      setFiles(editData?.files)
      setPreviewFiles(
        editData?.files?.map(file => {
          return URL.createObjectURL(file)
        })
      )
    }
  }, [formMode, AdvanceID, editData])

  const [
    createAPAdvance,
    {
      loading: createAPAdvanceLoading,
      called: createAPAdvanceCalled,
      error: createAPAdvanceError,
    },
  ] = useCreateApAdvanceMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: ({ createAPAdvance }) => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setTimeout(() => {
        if (!!isSubmit) {
          history.push({
            pathname: `/account-payable/${CompanyID}/advance/${createAPAdvance?.AdvanceID}/preview`,
          })
        } else {
          history.push({
            pathname: `/account-payable/${CompanyID}/advance`,
            state: { success: true, msgMode: 'create' },
          })
        }
      }, 500)
    },
  })

  const [
    updateAPAdvance,
    { loading: updateAPAdvanceLoading, called: updateAPAdvanceCalled },
  ] = useUpdateApAdvanceMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setTimeout(() => {
        if (!!isSubmit) {
          history.push({
            pathname: `/account-payable/${CompanyID}/advance/${AdvanceID ??
              data?.updateAPAdvance?.AdvanceID}/preview`,
          })
        } else {
          history.push({
            pathname: `/account-payable/${CompanyID}/advance`,
            state: { success: true, msgMode: 'update' },
          })
        }
      }, 500)
    },
  })

  const [val, setVal] = useState(false)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')

  const onSubmit = (data, status) => {
    if (val == false) {
      setVal(true)
      if (formMode === 'add') {
        createAPAdvance({
          variables: {
            input: {
              CompanyID,
              DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
              TransactionDate: formatDashDate(
                new Date(data?.TrxDate)?.toISOString()
              ),
              RefNo: data.RefNo,
              CreditorAccountID: data.CreditorAccountID,
              PaymentMethodID: data.PaymentMethodID,
              CreditCardID: data.CreditCardID,
              BankAccountID: data.BankAccountID,
              Description: data.Description,
              Remark: data.Remark,
              Attachment: files,
              ChequeNo: data.ChequeNo,
              ChequeDate: data.ChequeDate,
              ChequeExpiryDate: !!data?.ChequeDate
                ? changeDateFormat(
                    getDatePlusDay(data?.ChequeDate, 180),
                    'DD MMM YYYY'
                  )
                : null,
              ApprovalStatus: statusInput(status),
              DocAmt: data?.DocAmt,
            },
          },
          refetchQueries: [
            { query: GetApAdvanceDocument },
            { query: DocumentListingDocument },
          ],
        })
        // }
      } else if (formMode !== 'add') {
        updateAPAdvance({
          variables: {
            input: {
              CompanyID: CompanyID,
              AdvanceID: AdvanceID,
              DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
              TransactionDate: formatDashDate(
                new Date(data?.TrxDate)?.toISOString()
              ),
              RefNo: data.RefNo,
              CreditorAccountID: data.CreditorAccountID,
              PaymentMethodID: data.PaymentMethodID,
              CreditCardID: data.CreditCardID,
              BankAccountID: data.BankAccountID,
              DocAmt: data?.DocAmt,
              Description: data.Description,
              Remark: data.Remark,
              Attachment: files,
              ChequeNo: data.ChequeNo,
              ChequeDate: data.ChequeDate,
              ChequeExpiryDate: !!data?.ChequeDate
                ? changeDateFormat(
                    getDatePlusDay(data?.ChequeDate, 180),
                    'DD MMM YYYY'
                  )
                : null,
              ApprovalStatus: statusInput(status),
            },
          },
          refetchQueries: [
            {
              query: GetApAdvanceDocument,
            },
            {
              query: DocumentListingDocument,
              variables: {
                refTable: 'S_Attachment',
                refID: AdvanceID,
              },
            },
          ],
        })
      }
    }
  }

  let statusInput = mode => {
    let temp
    switch (mode) {
      case 'submit':
        temp = ApprovalStatus.Submit
        break
      case 'draft':
        temp = ApprovalStatus.Active
        break
      case 'approve':
        temp = ApprovalStatus.Approved
        break
      case 'reject':
        temp = ApprovalStatus.Rejected
        break
    }
    return temp
  }

  const docDateTimestamp = new Date(watch('DocDate'))
  const yearDocDate = docDateTimestamp.getFullYear()
  const monthDocDate = (docDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayDocDate = docDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const transferDate = `${yearDocDate}-${monthDocDate}-${dayDocDate}`

  const trxDateTimestamp = new Date(watch('TrxDate'))
  const yearTrxDate = trxDateTimestamp.getFullYear()
  const monthTrxDate = (trxDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayTrxDate = trxDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const trxDate = `${yearTrxDate}-${monthTrxDate}-${dayTrxDate}`

  const openPeriod1 =
    transferDate <= latestOpenPeriodCheckingDate?.StartDate ||
    transferDate >= latestOpenPeriodCheckingDate?.EndDate

  const openPeriod2 =
    trxDate >= latestOpenPeriodCheckingDate?.StartDate &&
    trxDate <= latestOpenPeriodCheckingDate?.EndDate

  const checkingYearClose1 = openPeriod1 ? true : false
  const checkingYearClose2 = openPeriod2 ? false : true

  const createUpdateLoading = editData
    ? updateAPAdvanceLoading
    : createAPAdvanceLoading

  const createUpdateCalled = editData
    ? updateAPAdvanceCalled
    : createAPAdvanceCalled

  const createdPeriodStartDate = getCreatedAccPeriodDateRange?.StartDate
  const createdPeriodEndDate = getCreatedAccPeriodDateRange?.EndDate
  const hasCreatedPeriodRange =
    !!createdPeriodStartDate && !!createdPeriodEndDate

  const isTrxDateOutsideCreatedPeriodRange =
    hasCreatedPeriodRange &&
    !!trxDate &&
    (trxDate < createdPeriodStartDate || trxDate > createdPeriodEndDate)


  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker()
  /**ACL */

  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'draft'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },

    disabled: checkingYearClose2
      ? true
      : handlePermDisabled({
          companyID: CompanyID,
          permEnum: AcctPermission.AccPayableAdvancesDraft,
        }),
  }

  const rejectFooterOption = {
    name: 'Save',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'reject'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },

    disabled:
      !!errors?.DocDate ||
      !!errors?.TrxDate ||
      !!errors?.RefNo ||
      !!errors?.Amount ||
      !!errors?.CreditorAccountID ||
      !!errors?.PaymentMethodID ||
      !!errors?.BankAccountID ||
      !!errors?.Description ||
      checkingYearClose2
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccPayableAdvancesUpdate,
          }),
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: e => {
      handleSubmit(data =>
        getDocumentNumberHeader?.filter(x => x?.RefTable === 'AP_Advance')
          ?.length === 0
          ? (setOpenSnackBar(true),
            setSnackBarMsg(SystemMsgs.errorNumberingStructure()))
          : !createUpdateCalled && onSubmit(data, 'submit')
      )()
      setIsSubmit(true)
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled: checkingYearClose2 === false ? false : true,
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  const [openExitConf, setOpenExitConf] = useState(null)

  /* -------------------------------------------- */
  /*               EXIT CONFIRMATION              */
  /* -------------------------------------------- */
  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: editData,
      initFiles: initDocs,
      currFiles: files?.map(file => file?.name),
      formMode: formMode,
    })

  return (
    <>
      {createUpdateLoading && <Loading />}
      {CreditorAccountCompanyAssignmentLoading && <Loading />}
      {PaymentMethodLoading && <Loading />}
      {CreditCardTypeLoading && <Loading />}
      {bankAccountLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {CompanyLoading && <Loading />}
      {openPeriodCheckDateLoading && <Loading />}

      <MainHeader
        mainBtn="close"
        onClick={() => {
          hasChanges() === true
            ? setOpenExitConf(true)
            : history.push(`/account-payable/${CompanyID}/advance`)
          localStorage.removeItem('DebitAmt')
        }}
        smTitle={'Account Payable'}
        title={curCompany[0]?.Name}
        routeSegments={[
          { name: 'Account Payable' },
          { name: 'Advance Listing' },
          { name: 'Advance', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              mode === 'add'
                ? 'New'
                : mode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />
      <ContentWrapper float footer>
        <CardContents>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              required
              as={KeyboardDatePicker}
              name="DocDate"
              label="Date"
              control={control}
              onChange={(date: Date | null) => {
                //date
              }}
              // onAccept={(date: Date | null) => {
              //   updateNewPaymentItem(date, taxEffectiveList)
              // }}
              format="dd/MM/yyyy"
              value={watch(formMode === 'add' ? new Date() : editData?.DocDate)}
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              defaultValue={editData ? editData?.DocDate : new Date()}
              showTodayButton
              className="left"
              disabled={mode == 'approve-reject'}
              style={{
                paddingTop: '10px',
              }}
              // minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
              // maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
              // helperText={
              //   checkingYearClose1
              //     ? 'Financial Period already closed'
              //     : errors?.DocDate?.message
              // }
              // error={errors?.DocDate || checkingYearClose1 ? true : false}
            />
          </MuiPickersUtilsProvider>

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="TrxDate"
              required
              label="Transaction Date"
              control={control}
              format="dd/MM/yyyy"
              margin="normal"
              allowKeyboardControl
              onChange={(date: Date | null) => {}}
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              showTodayButton
              className="right"
              value={new Date()}
              defaultValue={editData ? editData?.TransactionDate : new Date()}
              minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
              maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
              helperText={
                isTrxDateOutsideCreatedPeriodRange
                  ? 'Accounting period not created'
                  : checkingYearClose2
                  ? 'Financial Period already closed'
                  : errors?.TrxDate?.message
              }
              error={
                errors?.TrxDate ||
                isTrxDateOutsideCreatedPeriodRange ||
                checkingYearClose2
                  ? true
                  : false
              }
            />
          </MuiPickersUtilsProvider>

          <Controller
            as={TextField}
            id="standard-basic"
            name="RefNo"
            label="Reference No."
            className="left"
            required
            autoComplete="off"
            control={control}
            margin="dense"
            ref={register}
            helperText={errors?.RefNo?.message}
            error={errors?.RefNo ? true : false}
            defaultValue={editData ? editData?.RefNo : ''}
            disabled={mode == 'approve-reject'}
          />

          <Controller
            render={({ onChange }) => (
              <NumberFormat
                allowNegative={true}
                customInput={TextField}
                decimalScale={2}
                fixedDecimalScale
                autoComplete="off"
                thousandSeparator
                isNumericString
                className="right"
                margin="dense"
                helperText={errors?.DocAmt && errors?.DocAmt.message}
                error={errors?.DocAmt ? true : false}
                onValueChange={values => {
                  let { floatValue } = values
                  onChange(
                    values.floatValue,
                    register(`DocAmt`),
                    setValue(`DocAmt`, floatValue)
                  )
                }}
                label="Amount"
                // InputLabelProps={{ shrink: true }}
                defaultValue={editData?.DocAmt ?? 0}
                required
              />
            )}
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            className="right"
            name="DocAmt"
            label="Amount"
            required
            helperText={errors?.DocAmt?.message}
            error={errors?.DocAmt ? true : false}
            defaultValue={editData?.DocAmt ?? 0}
          />

          {!CreditorAccountCompanyAssignmentLoading && (
            <Controller
              render={({ value, onChange }) => {
                const defVal = creditorAcc?.filter(
                  x => x?.CreditorAccountID === editData?.CreditorAccountID
                )[0]
                return (
                  <Autocomplete
                    options={
                      creditorAcc?.sort((a, b) => {
                        return a.CompanyName.localeCompare(b.CompanyName)
                      }) || []
                    }
                    getOptionLabel={option => `${option?.CompanyName}`}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      setValue('CreditorAccountID', newValue?.CreditorAccountID)
                    }}
                    renderOption={(props, option) => {
                      return <span>{props?.CompanyName}</span>
                    }}
                    defaultValue={defVal}
                    disabled={mode === 'approve-reject'}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.CreditorAccountID?.message}
                            error={errors?.CreditorAccountID ? true : false}
                            label="Creditor Name"
                            style={{ width: '100%' }}
                            margin="dense"
                            required
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              label="Creditor Name"
              name="CreditorAccountID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="dense"
              ref={register}
              helperText={errors?.CreditorAccountID?.message}
              error={errors?.CreditorAccountID ? true : false}
              defaultValue={editData?.CreditorAccountID}
              required
              disabled={mode === 'approve-reject'}
            />
          )}
          <Controller
            render={({ onChange, value }) => (
              <TextField
                label="Payment Method"
                required
                margin="dense"
                select
                value={value}
                onChange={e => {
                  onChange()
                  handlePMChange(e)
                  setValue('PaymentMethodID', e?.target?.value)
                }}
                defaultValue={editData ? editData?.PaymentMethodID : ''}
                disabled={formMode === 'approve-reject'}
                helperText={errors?.PaymentMethodID?.message}
                error={errors?.PaymentMethodID ? true : false}
              >
                {getPaymentMethod
                  ?.sort((a, b) => {
                    return a.Name.localeCompare(b.Name)
                  })
                  .map((el, index) => (
                    <MenuItem key={index} value={el.PaymentMethodID}>
                      {el.Name}
                    </MenuItem>
                  ))}
              </TextField>
            )}
            control={control}
            helperText={errors?.PaymentMethodID?.message}
            error={errors?.PaymentMethodID ? true : false}
            onChange={e => {
              //handlePMChange(e)
              setValue('PaymentMethodID', e?.target?.value)
            }}
            ref={register()}
            name="PaymentMethodID"
            autoComplete="off"
            value={editData?.PaymentMethodID}
            margin="dense"
            multiline={true}
            fullWidth
            required
          />

          {getPaymentMethod
            .find(el => el.PaymentMethodID === watch('PaymentMethodID'))
            ?.Name?.includes('Card') && (
            <Controller
              render={({ onChange, value }) => (
                <TextField
                  select
                  required
                  name="CreditCardID"
                  label="Card Type"
                  onChange={e => {
                    onChange(e)
                    handleCCChange(e)
                    //setValue('CreditCardID', e?.target?.value)
                  }}
                  defaultValue={editData ? editData?.CreditCardID : ''}
                  disabled={mode == 'approve-reject'}
                  // helperText={errors?.CreditCardID?.message}
                  // error={errors?.CreditCardID ? true : false}
                >
                  {getCreditCardType
                    ?.sort((a, b) => {
                      return a.Name.localeCompare(b.Name)
                    })
                    .map((el, index) => (
                      <MenuItem key={index} value={el.CreditCardID}>
                        {`${el.Name}`}
                      </MenuItem>
                    ))}
                </TextField>
              )}
              label="Card Type"
              name="CreditCardID"
              autoComplete="off"
              control={control}
              // helperText={errors?.CreditCardID?.message}
              // error={errors?.CreditCardID ? true : false}
              multiline={true}
              // defaultValue={getPayment[0]?.CreditCardID}
              fullWidth
              margin="dense"
              ref={register}
            />
          )}

          {getPaymentMethod.find(
            el => el.PaymentMethodID === watch('PaymentMethodID')
          )?.Name === 'Cheque' && (
            <>
              <Controller
                as={TextField}
                id="standard-basic"
                name="ChequeNo"
                label="Cheque No"
                className="left"
                required
                autoComplete="off"
                control={control}
                margin="dense"
                ref={register}
                // helperText={errors?.ChequeNo?.message}
                // error={errors?.ChequeNo ? true : false}
                defaultValue={editData ? editData?.ChequeNo : ''}
                disabled={mode == 'approve-reject'}
              />

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Controller
                  required
                  as={KeyboardDatePicker}
                  name="ChequeDate"
                  label="Cheque Date"
                  control={control}
                  onChange={(date: Date | null) => {}}
                  format="dd/MM/yyyy"
                  value={
                    // formMode === 'add' ? new Date() : editData?.ChequeDate
                    watch('ChequeDate')
                  }
                  margin="dense"
                  allowKeyboardControl
                  //inputRef={register({})}
                  ref={register}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  defaultValue={
                    formMode === 'add' ? new Date() : editData?.ChequeDate
                  }
                  showTodayButton
                  className="right"
                  disabled={mode == 'approve-reject'}
                  // helperText={errors?.ChequeDate?.message}
                  // error={errors?.ChequeDate ? true : false}
                />
              </MuiPickersUtilsProvider>
            </>
          )}

          <DropdownTextfield
            // mount={bankNameNeeded}
            disabled={formMode === 'approve-reject' ? true : false}
            helperText={errors?.BankAccountID?.message}
            error={errors?.BankAccountID ? true : false}
            label="Company Bank Account No"
            handleChangeEnabled
            handleChange={handleBankChange}
            selectProps={{
              renderValue: () =>
                `${selectedBank?.AccountNo} (${selectedBank?.BankProfile?.Name})`,
            }}
            customDropdown={getBankAccount
              ?.sort((a, b) => {
                return a.BankProfile?.Name.localeCompare(b.BankProfile?.Name)
              })
              ?.map((el, index) => (
                <MenuItem
                  id="contract-select"
                  key={index}
                  value={el?.BankAccountID}
                >
                  <div className="content-wrap full">
                    <div>
                      <span className="xsTitle">{el.BankProfile?.Name}</span>
                    </div>
                    <div className="desc">
                      Account No: {`${el?.AccountNo} (${el?.Code})`}
                    </div>
                  </div>
                </MenuItem>
              ))}
            name="BankAccountID"
            control={control}
            register={register}
            // defaultValue={watch(`BankAccountID`)}
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="Description"
            label="Description"
            required
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            helperText={errors?.Description?.message}
            error={errors?.Description ? true : false}
            ref={register}
            defaultValue={
              formMode === 'edit' || mode === 'approve-reject'
                ? editData?.Description
                : ''
            }
            disabled={mode === 'approve-reject'}
          />

          <VoiceTextField
            mounted={true}
            label="Remark"
            name="Remark"
            value={voiceRemark}
            setValue={setValue}
            record={record}
            setRecord={setRecord}
            control={control}
            controllerProps={{
              error: errors?.Remark ? true : false,
              helperText: errors?.Remark?.message,
              ref: register,
              autoComplete: 'off',
            }}
          />

          <DocUploadInput
            placeholder={previewFiles.length === 0 ? 'Attachment' : null}
            label={previewFiles.length > 0 ? 'Attachment' : null}
            files={files}
            onHandleUploadChange={handleUploadChange}
            multiple
            accept={
              'application/msword, application/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            }
            mapData={'application'}
            imagePreview={
              <>
                {previewFiles?.map((v, i) => (
                  <UploadPreview
                    remove
                    key={v}
                    src={v}
                    onClick={() => removeFile(i)}
                    mediaType={
                      // files[i]?.type
                      files[i]?.type ?? DocData?.DocumentListing[i]?.mediaType
                    }
                  />
                ))}
              </>
            }
            disabled={mode === 'approve-reject'}
          />
        </CardContents>
      </ContentWrapper>

      {footerOptions?.length > 0 ? (
        <Footer options={[...footerOptions]} />
      ) : null}

      <CommonDialog
        fullWidth={true}
        open={openExitDialog}
        onClose={() => setopenExitDialog(false)}
        sections={{
          header: {
            title: 'Exit Confirmation',
          },
          body: () => (
            <>
              <div>
                Are you sure you want to exit? Your changes will not be saved.
              </div>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setopenExitDialog(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => history.goBack(),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/account-payable/${CompanyID}/advance`)
        }}
      />
    </>
  )
}
